import React, { useState}  from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { notification } from 'antd'
import { BiTrash } from 'react-icons/bi'
import CharacterList from '../../components/character-list/'
import Button from '../../components/button/'
import Container from '../../styled/styled-container'
import { del } from '../../redux/actions'

const Home = () => {

    const [select, setSelect] = useState(undefined)
    const dispatch = useDispatch()
    const characters = useSelector((state) => state.charactersHome.charactersHome)
    
    const handleSelectPokemon = (event) => {   
      setSelect(event.target.value)
    }

    const handleSelectRickAndMorty = (event) => {
      setSelect(event.target.value)
    }
    
    const handleShowAll = (event) => {
      setSelect(event.target.value)
    }

    const handleSelected = (selectedCharacter) => {
      dispatch(del(selectedCharacter))
      
      localStorage.setItem('characters', JSON.stringify(characters.filter(character => character.name !== selectedCharacter.name)))
      notification['open']({
        message: 'Excluir',
        description:`${selectedCharacter.name} excluido com sucesso!`,
        icon: <BiTrash style={{ color: '#ff4d4f' }} />,
        style:{width:'300px', right: '10px'}
      })
      
    }
    
    return(
      <Container >
        
        <Button onClick={handleShowAll} value={undefined} buttonTitle='Show All'/>
        <div>
          <Button onClick={handleSelectPokemon} value='pokemon' buttonTitle='Pokemon'/>
          <Button onClick={handleSelectRickAndMorty} value='rick-and-morty' buttonTitle='Rick and Morty' />
        </div>
        <CharacterList
          onSelect={handleSelected}
          characters={select === 'pokemon' ?
            characters.filter(character => character.id === undefined) :
            select === 'rick-and-morty' ?
            characters.filter(character => character.id !== undefined) :
            characters }/>
        </Container>
    )
}

export default Home